<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.65605 7.01315C9.65605 6.59894 9.99184 6.26315 10.4061 6.26315H16.9061C17.3203 6.26315 17.6561 6.59894 17.6561 7.01315C17.6561 7.42736 17.3203 7.76315 16.9061 7.76315H10.4061C9.99184 7.76315 9.65605 7.42736 9.65605 7.01315Z"
      fill="currentColor"
    />
    <path
      d="M9.65605 14.0132C9.65605 13.5989 9.99184 13.2632 10.4061 13.2632H16.9061C17.3203 13.2632 17.6561 13.5989 17.6561 14.0132C17.6561 14.4274 17.3203 14.7632 16.9061 14.7632H10.4061C9.99184 14.7632 9.65605 14.4274 9.65605 14.0132Z"
      fill="currentColor"
    />
    <path
      d="M5.15294 3.42224V8.51315H4.07659V4.4439H4.04676L2.88093 5.17473V4.22018L4.14122 3.42224H5.15294Z"
      fill="currentColor"
    />
    <path
      d="M7.6375 8.57778C7.47343 8.57778 7.33257 8.51978 7.21491 8.40378C7.09891 8.28611 7.0409 8.14525 7.0409 7.98119C7.0409 7.81878 7.09891 7.67958 7.21491 7.56358C7.33257 7.44757 7.47343 7.38957 7.6375 7.38957C7.79659 7.38957 7.93579 7.44757 8.05511 7.56358C8.17443 7.67958 8.23409 7.81878 8.23409 7.98119C8.23409 8.09057 8.20591 8.19083 8.14957 8.28197C8.09488 8.37146 8.02279 8.44355 7.93331 8.49824C7.84382 8.55127 7.74521 8.57778 7.6375 8.57778Z"
      fill="currentColor"
    />
    <path
      d="M2.39371 16.5132V15.7376L4.20585 14.0597C4.35997 13.9105 4.48924 13.7763 4.59364 13.657C4.6997 13.5377 4.78007 13.4208 4.83476 13.3065C4.88945 13.1905 4.91679 13.0654 4.91679 12.9311C4.91679 12.782 4.88282 12.6535 4.81487 12.5458C4.74693 12.4364 4.65413 12.3528 4.53647 12.2948C4.4188 12.2351 4.2854 12.2053 4.13625 12.2053C3.98048 12.2053 3.84459 12.2368 3.72858 12.2997C3.61258 12.3627 3.52309 12.453 3.46012 12.5707C3.39714 12.6883 3.36566 12.8284 3.36566 12.9908H2.34399C2.34399 12.6577 2.4194 12.3685 2.5702 12.1232C2.72101 11.878 2.9323 11.6882 3.20408 11.554C3.47586 11.4198 3.78907 11.3526 4.14371 11.3526C4.50829 11.3526 4.82565 11.4173 5.09577 11.5465C5.36755 11.6741 5.57884 11.8515 5.72965 12.0785C5.88045 12.3055 5.95585 12.5657 5.95585 12.859C5.95585 13.0513 5.91774 13.241 5.84151 13.4283C5.76693 13.6155 5.63353 13.8235 5.4413 14.0522C5.24906 14.2792 4.97811 14.5519 4.62844 14.87L3.88519 15.5984V15.6332H6.02297V16.5132H2.39371Z"
      fill="currentColor"
    />
    <path
      d="M7.6375 16.5778C7.47343 16.5778 7.33257 16.5198 7.21491 16.4038C7.09891 16.2861 7.0409 16.1453 7.0409 15.9812C7.0409 15.8188 7.09891 15.6796 7.21491 15.5636C7.33257 15.4476 7.47343 15.3896 7.6375 15.3896C7.79659 15.3896 7.93579 15.4476 8.05511 15.5636C8.17443 15.6796 8.23409 15.8188 8.23409 15.9812C8.23409 16.0906 8.20591 16.1908 8.14957 16.282C8.09488 16.3715 8.02279 16.4435 7.93331 16.4982C7.84382 16.5513 7.74521 16.5778 7.6375 16.5778Z"
      fill="currentColor"
    />
  </svg>
</template>
